import { IconName, isCompound, type Quote, useCallbackRef, useSecuritiesContext } from '@talos/kyoko';
import type { MenuItemDef } from 'ag-grid-community';
import { useNavigate } from 'react-router-dom';
import { useAppLayoutId } from '../../../../hooks/useAppLayoutId';
import { getTakerQuoteBreakdownRoute } from '../../../Routes/routes';

export const useShowTakerQuoteBreakdownMenuItem = () => {
  const navigate = useNavigate();
  const layoutId = useAppLayoutId('trading');
  const { securitiesBySymbol } = useSecuritiesContext();

  return useCallbackRef((quote: Quote): MenuItemDef | undefined => {
    const security = securitiesBySymbol.get(quote.Symbol);
    if (!isCompound(security)) {
      return undefined;
    }

    return {
      name: 'Quote Breakdown',
      action: () => navigate(getTakerQuoteBreakdownRoute({ rfqID: quote.RFQID, layoutId })),
      icon: `<i class="ag-icon ${IconName.Deepdive}"/>`,
    };
  });
};
